import { Steps, Button, Space, Alert } from 'antd';
import { useContext } from 'react';
import { TradesContext } from '../../contexts/tradeProcessContext';
import MatchingForm from './MatchingForm';
import MatchingTable from './MatchingTable';
import SuccessfulResponse from './SuccessfulResponse';

const steps = [
  {
    title: 'Matching',
    content: <MatchingForm />,
  },
  {
    title: 'Trading',
    content: <MatchingTable />,
  },
  {
    title: 'Finished',
    content: <SuccessfulResponse />,
  },
];

const StepCounter = () => {
  const { currentStep, setCurrentStep, resetForm, setOpenModal, validateForm, tradeResponse, setTradeResponse, matchingData, setMatchingData } =
    useContext(TradesContext);
  const items = steps.map(item => ({ key: item.title, title: item.title }));

  const handleStartMatching = async () => {
    const values = await validateForm();
    if (values) {
      setOpenModal(true);
    }
    // updates counter inside handleOk function
  };

  // reset every states
  const handleMatchAgain = () => {
    setMatchingData(
      {
        success: false,
        records: [],
      }
    );
    setTradeResponse(null)
    setCurrentStep(0);
    resetForm();

    console.log(matchingData, "clicked Match Again")
  };

  const handleStartTrading = async () => {
    setOpenModal(true)
  };

  return (
    <div
      style={{
        maxWidth: '1024px',
        margin: '0 auto',
      }}
    >
      <Space
        direction="vertical"
        size={'large'}
        style={{
          width: '100%',
        }}
      >
        <Steps
          current={currentStep}
          items={items}
        />
        {currentStep !== steps.length - 1 && (
          <Alert
            type='warning'
            showIcon
            message={
              <strong>Important !</strong>
            }
            description={
              <div>
                <p>- Matching needs to be performed before the trade process.</p>
                <p>- Transfer Window date should be <strong>+2 business days</strong> of trade window.
                </p>
                <p>- Settlement Window date should be <strong>+3 business days</strong> of trade window.
                </p>
              </div>
            }
          />
        )}
        <div>{steps[currentStep].content}</div>
        <div>
          {currentStep === 0 && (
            <Button
              type="primary"
              style={{
                float: 'right',
              }}
              onClick={handleStartMatching}
            >
              Start Matching
            </Button>
          )}
          {currentStep > 0 && currentStep < steps.length - 1 && !matchingData.success && (
            <Alert
              type="error"
              showIcon
              message={<strong>Not match ! </strong>}
              description={
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end',
                  }}
                >
                  <div>
                    <p>Trade process cannot be proceeded.</p>
                    <p>Please contact the administrator.</p>
                  </div>
                  <Button
                    style={{
                      float: 'right',

                    }}
                    onClick={handleMatchAgain}
                  >
                    Match Again
                  </Button>
                </div>
              }
            />

          )}
          {currentStep === 1 && matchingData.success && !tradeResponse && (
            <Button
              type="primary"
              style={{
                float: 'right',
                marginLeft: '16px'
              }}
              onClick={handleStartTrading}
            >
              Start Trading
            </Button>
          )}
          {currentStep === steps.length - 1 && (
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: tradeResponse !== null ? 'end' : 'center',
              }}
            >
              <Button
                type="primary"
                style={{
                  float: 'right',
                  marginLeft: '16px',
                }}
                onClick={handleMatchAgain}
              >
                Trade Again
              </Button>
            </div>
          )}
        </div>
      </Space>
    </div>
  );
};

export default StepCounter;
